// Vendors
import React from 'react';
// Constants
import { IFRAME_PROPS } from 'components/iframe/constants/iframe.constants';
// Hooks
import { useIframeHook } from 'components/iframe/hooks/iframe.hook';
// Styles
import { IframeComponentStyled } from './iframe.component.styled';
// Types
import { IframeComponentType } from './types/iframe.component.type';

const IframeComponent = ({ frameGap, ...props }: IframeComponentType): React.JSX.Element => {
  const {
    handleCheckFrameComponentLoadSuccessEvent: onLoad,
    handleCatchFrameComponentLoadErrorEvent: onError,
    src,
  } = useIframeHook(props);

  return <IframeComponentStyled {...{ ...IFRAME_PROPS, frameGap, onError, onLoad, src }} />;
};

export { IframeComponent };
